<template>
  <div class="w-full text-center flex flex-col justify-evenly">
    <div
      class="w-full text-center antialiased font-black pb-2 md:pb-4 mb-2 mt-4"
      :class="[computedHeadingSize, computedHeadingColor]"
    >
      <slot name="heading"></slot>
    </div>
    <div class="w-full">
      <div
        ref="blobContainer"
        class="w-full p-2 sm:p-6 mx-auto shadow-2xl text-gray-300 rounded-lg text-left"
        :class="[computedBlobSize, computedBlobColor]"
      >
        <slot name="text"></slot>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from "vue";

const blobContainer = ref(null);

const props = defineProps({
  headingSize: {
    type: String,
    default: "l",
  },
  blobSize: {
    type: String,
    default: "xxl",
  },
  blobColor: {
    type: String,
    default: "gray",
  },
});

watch(
  () => props.isDataLoaded,
  (newVal) => {
    if (newVal) {
      const contentHeight = blobContainer.value.scrollHeight;
      blobContainer.value.style.height = `${contentHeight}px`;
    }
  }
);

//TODO: heading mapping doesn't seem to work as expected
const sizeMapping = {
  heading: {
    s: "md:text-4xl",
    m: "md:text-5xl",
    l: "text-3xl md:text-6xl",
    xl: "md:text-7xl",
  },
  blob: {
    s: "sm:w-1/3",
    m: "sm:w-1/2",
    l: "sm:w-2/3",
    xl: "sm:w-3/4",
    xxl: "sm:w-4/5",
    full: "sm:w-full",
  },
};

const colorMapping = {
  heading: {
    black: "text-black",
    white: "text-white",
    gray: "text-gray-300",
    green: "text-green-300",
    red: "text-red-300",
  },
  blob: {
    black: "bg-black",
    white: "bg-white",
    gray: "bg-gray-800",
    green: "bg-green-800",
    red: "bg-red-800",
  },
};

const computedHeadingSize = computed(
  () => sizeMapping.heading[props.headingSize]
);
const computedBlobSize = computed(() => sizeMapping.blob[props.blobSize]);
const computedHeadingColor = computed(
  () => colorMapping.heading[props.blobColor]
);
const computedBlobColor = computed(() => colorMapping.blob[props.blobColor]);
</script>
